import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-navy-deep flex flex-col items-center justify-center text-center px-6 relative overflow-hidden">
      <div className="spotlight absolute inset-0 pointer-events-none" />
      <span className="flex h-14 w-14 items-center justify-center rounded-full border border-gold/50 bg-gold/10 relative"><Compass className="h-7 w-7 text-gold" /></span>
      <h1 className="font-playfair text-6xl text-warm mt-8 relative">404</h1>
      <p className="text-warm/60 mt-4 relative">This route isn't on the map — yet.</p>
      <Link to="/" data-testid="notfound-home" className="mt-8 rounded-full bg-gold px-8 py-3 font-600 text-navy hover:bg-gold-soft transition-colors relative">Back to the journey</Link>
    </div>
  );
}
